import { TextField } from "@mui/material";
import { isUndefined } from "lodash";
import React from "react";

const InputField = (props) => {
  const {
    label,
    name,
    className,
    value,
    onChange,
    required,
    disabled,
    multiline = false,
    rows,
    size,
    defaultValue,
    inputLabelProps = {},
    error,
    type = "input",
  } = props || {};

  const inputValue = value === null ? "" : value;
  const errorMessage = typeof error !== "string" ? error?.[name] : error;
  const hasError = !isUndefined(errorMessage);

  return (
    <TextField
      label={label}
      name={name}
      defaultValue={defaultValue}
      rows={rows}
      multiline={multiline}
      error={hasError}
      className={`${className} mb-4`}
      helperText={errorMessage}
      value={inputValue}
      onChange={(event) => {
        onChange?.(event);
      }}
      disabled={!!disabled}
      required={required}
      fullWidth
      size={size}
      type={type}
      InputLabelProps={inputLabelProps}
    />
  );
};

export default InputField;
